import { NgModule } from '@angular/core';
import { SharedModule } from 'app/components/shared.module';
import { SectionModule } from 'app/views/presentations/layouts/layouts/section.module';
import { ThreeSectionsLayout4, ThreeSectionsLayout4Component } from 'app/views/presentations/layouts/layouts/threeSectionsLayout4/threeSectionsLayout4.component';
import { LayoutWrapperModule } from 'app/views/presentations/layouts/layoutWrapper.module';

@NgModule({
    imports: [
        SharedModule,
        SectionModule,
        LayoutWrapperModule.wrapLayout(ThreeSectionsLayout4)
    ],
    declarations: [
        ThreeSectionsLayout4Component
    ],
    entryComponents: [
        ThreeSectionsLayout4Component
    ]
})
export class ThreeSectionsLayout4Module { }


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/threeSectionsLayout4/threeSectionsLayout4.module.ts